import { ru } from 'date-fns/locale/ru'
import moment from 'moment'
import { forwardRef } from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import style from './DatesRangeFilter.module.scss'
import Search from './search.svg'

import './calendar.css'

registerLocale('ru', ru)

interface IProps {
    startDate: string | null
    endDate: string | null
    onSetStartDate: (date: string | null) => void
    onSetEndDate: (date: string | null) => void
    onGetInsuredsList: () => void
}

export const DatesRangeFilter = (props: IProps) => {
    const { onGetInsuredsList, onSetStartDate, onSetEndDate, endDate, startDate } = props
    return (
        <ReactDatePicker
            wrapperClassName={style.wrapperClassName}
            selectsRange={true}
            startDate={startDate ? new Date(startDate) : null}
            endDate={endDate ? new Date(endDate) : null}
            locale='ru'
            dateFormat='dd.MM.YYYY'
            onChange={(update: [Date | null, Date | null]) => {
                const [_startDate, _endDate] = update
                const SD = _startDate ? moment(_startDate).format('YYYY-MM-DD') : null
                const ED = _endDate ? moment(_endDate).format('YYYY-MM-DD') : null
                onSetStartDate(SD)
                onSetEndDate(ED)
            }}
            customInput={<CustomDateInput onGetInsuredsList={onGetInsuredsList} isSearch={!!startDate && !!endDate} />}
            // isClearable={true}
            // withPortal
        />
    )
}

const CustomDateInput = forwardRef(
    (
        {
            isSearch,
            value,
            onClick,
            onGetInsuredsList
        }: { isSearch: boolean; value?: string; onClick?: () => void; onGetInsuredsList: () => void },
        ref
    ) => (
        <div className={style.container} onClick={onClick} ref={ref as any} style={{ width: '100%' }}>
            <span style={{ opacity: !value ? '0.54' : '1' }}>{value || 'Укажите даты'}</span>
            {isSearch && (
                <div
                    className={style.searchWrapper}
                    onClick={(e) => {
                        e.stopPropagation()
                        onGetInsuredsList()
                    }}
                >
                    <Search />
                </div>
            )}
        </div>
    )
)

CustomDateInput.displayName = 'CustomDateInput'
